import PropTypes from 'prop-types';

const ImageSource = {};

ImageSource.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  media: PropTypes.number,
  imageSrc: PropTypes.string,
};

ImageSource.viewModelMeta = 'ignore';

export default ImageSource;
